import { useState } from 'react'
import { createModel } from 'hox'
import useStorageState from '../hooks/useStorageState'
import { PaginationProps } from 'antd/es/pagination'
import { IPgProps, ISelectOptions } from '@/types/AppTypes'
import { vehicleService } from '@/views/base/vehicle/vehicleService'
import { driverService } from '@/views/base/driver/driverService'
import { trailerService } from '@/views/base/trailer/trailerService'
import { supercargoService } from '@/views/base/supercargo/supercargoService'
import { maintenanceTechnicianService } from '@/views/base/maintenanceTechnician/maintenanceTechnicianService'
import { routineService } from '@/views/base/routine/routineService'
import { fleetService } from '@/views/base/fleet/fleetService'
import { authService } from '@/views/base/auth/authService'
import { threeTestItemService } from '@/views/base/threeTestItem/threeTestItemService'

export function transPgToPagination(pg: IPgProps): PaginationProps {
    return {
        total: pg.total,
        pageSize: pg.size,
        current: pg.current,
    }
}

export type UserType = {
    id?: string
    userName?: string
    password?: String
    token?: string
    shopId?: string
    shopName?: string
    shopCode?: string
    loginType?: 'account' | 'token'
    deviceId?: string
    userId?: string
    accountName?: string
    userType?: string
    dealerName?: string
    [key: string]: any
}

export interface ICiStaticResourcesType {
    image: string
    video: string
}

export type LoadingType = { loadingVisible: boolean; txt: string }

type GlobalModelType = {
    user: UserType
    setUser: (e: UserType) => void
    resetUser: () => void

    ciDict: any
    setCiDict: (e: any) => void
    resetCiDict: () => void
    ciGetTreeNodeValue: (string: string) => string | undefined

    ciStaticResources: ICiStaticResourcesType
    setCiStaticResources: (e: ICiStaticResourcesType) => void
    resetCiStaticResources: () => void
    getCiImgUrl: (string: string) => string

    toggleMenu: () => void
    cm: CmType
    resetCm: () => void
    loadingInfo: LoadingType
    setLoadingInfo: (origin: LoadingType) => void

    whDs: ISelectOptions[]

    beDs: ISelectOptions[]
    setBeDs: (value: ISelectOptions[] | ((previousState?: ISelectOptions[] | undefined) => ISelectOptions[])) => void
    // beLoadDataAll: () => void,
    requestCacheAll: (shopCode?: string) => void
    fetchVehicleList: () => void
    fetchTrailerList: () => void
    fetchDriverList: () => void
    fetchSupercargoList: () => void
    fetchMaintenanceTechnicianList: () => void
    fetchRoutineList: () => void
    fetchCompanyList: () => void
    fetchFleetList: () => void
    fetchAuthList: () => void
    shopDs: ISelectOptions[]
    setShopDs: (origin: ISelectOptions[]) => void

    CustomerData: ISelectOptions[]
    setCustomerData: (origin: ISelectOptions[]) => void
    clearCustomerData: (origin: ISelectOptions[]) => void

    supplierDs: ISelectOptions[]
    // supplierLoadDataAll: (shopCode?: string) => void,

    resourceAuth: string[]
    setResourceAuth: (origin: string[]) => void

    menuAuth: string[]
    setMenuAuth: (origin: string[]) => void

    vehicleData: ISelectOptions[]
    setVehicleData: (origin: ISelectOptions[]) => void

    trailerData: ISelectOptions[]
    setTrailerData: (origin: ISelectOptions[]) => void

    driverData: ISelectOptions[]
    setDriverData: (origin: ISelectOptions[]) => void

    supercargoData: ISelectOptions[]
    setSupercargoData: (origin: ISelectOptions[]) => void

    maintenanceTechnicianData: ISelectOptions[]
    setMaintenanceTechnicianData: (origin: ISelectOptions[]) => void

    routineData: ISelectOptions[]
    setRoutineData: (origin: ISelectOptions[]) => void

    companyData: ISelectOptions[]
    setCompanyData: (origin: ISelectOptions[]) => void

    fleetData: ISelectOptions[]
    setFleetData: (origin: ISelectOptions[]) => void

    authData: ISelectOptions[]
    setAuthData: (origin: ISelectOptions[]) => void

    dictHeaderData: ISelectOptions[]
    setDictHeaderData: (origin: ISelectOptions[]) => void
    unreadNum: number

    dealerNameData: any[]
    setDealerNameData: (origin: any[]) => void
}

const initUserState = {
    id: '',
    userName: '',
    password: '',
    token: '',
    shopId: '',
    shopName: '',
    shopCode: '',
    userId: '',
    accountName: '',
}

type CmType = {
    collapsed: boolean
}
const initCmState = {
    collapsed: false,
}

function useModel(): GlobalModelType {
    //客户数据
    const [CustomerData, setCustomerData, clearCustomerData] = useStorageState<ISelectOptions[]>('customerList', [])
    //所有仓库
    const [whDs] = useStorageState<ISelectOptions[]>('tco.waerhouseDs', [])
    //经营实体
    const [beDs, setBeDs] = useStorageState<ISelectOptions[]>('beDs', [])
    //所有门店
    const [shopDs, setShopDs] = useStorageState<ISelectOptions[]>('tco.shopDs', [])
    //用户所有菜单权限
    const [menuAuth, setMenuAuth] = useStorageState<string[]>('tco.user.menus', [])
    //用户所有资源权限
    const [resourceAuth, setResourceAuth] = useStorageState<string[]>('tco.user.resource', [])
    //用户所有信息
    const [user, setUser, resetUser] = useStorageState<UserType>('tco.user', initUserState)
    // //所有供应商
    const [supplierDs] = useStorageState<ISelectOptions[]>('tco.supplierDs', [])
    const [cm, setCm, resetCm] = useStorageState<CmType>('tco.cm', initCmState)
    const [vehicleData, setVehicleData] = useStorageState<any[]>('vehicleData', [])
    const [trailerData, setTrailerData] = useStorageState<any[]>('trailerData', [])
    const [driverData, setDriverData] = useStorageState<any[]>('driverData', [])
    const [supercargoData, setSupercargoData] = useStorageState<any[]>('supercargoData', [])
    const [maintenanceTechnicianData, setMaintenanceTechnicianData] = useStorageState<any[]>('maintenanceTechnicianData', [])
    const [routineData, setRoutineData] = useStorageState<any[]>('routineData', [])
    const [companyData, setCompanyData] = useStorageState<any[]>('companyData', [])
    const [fleetData, setFleetData] = useStorageState<any[]>('fleetData', [])
    const [authData, setAuthData] = useStorageState<any[]>('authData', [])
    const [dictHeaderData, setDictHeaderData] = useStorageState<any>('dictHeaderData', [])
    //ci 数据字典
    const [ciDict, setCiDict, resetCiDict] = useStorageState<UserType>('ci.dictTree', initUserState)

    const [dealerNameData, setDealerNameData] = useStorageState<any[]>('dealerNameData', [])

    //根据code 返回对应的value 字典值 （例如， 币种的符号）
    const ciGetTreeNodeValue = (code: string): any => {
        return ciDict.find((i: any) => i.dictCode === code)?.dictName
    }

    //ci 图片资源地址
    const [ciStaticResources, setCiStaticResources, resetCiStaticResources] = useStorageState<ICiStaticResourcesType>('ci.staticResources', {
        image: '',
        video: '',
    })
    const getCiImgUrl = (md5: string) => {
        if (ciStaticResources && ciStaticResources.image) {
            return `${ciStaticResources.image}${md5}`
        } else {
            return ''
        }
    }

    //全局loading
    const [loadingInfo, setLoadingInfo] = useState<LoadingType>({ loadingVisible: false, txt: '' })

    const toggleMenu = () => {
        setCm({
            ...cm,
            collapsed: !cm.collapsed,
        })
    }

    // 实时查询车辆接口
    const fetchVehicleList = async () => {
        let data = {
            pageSize: -1,
            pageNum: 1,
            createUserId: user.shopCode,
            type: '卡车',
            vehicleSite: user.userType === '管理员' || user.userType === '超级管理员' ? user.createUser : '',
        }
        let { retData } = await vehicleService.page(data)
        const { records } = retData
        setVehicleData(
            records?.map((item) => ({
                label: item.licensePlate,
                value: item.id,
            })),
        )
    }
    // 实时查询挂车接口
    const fetchTrailerList = async () => {
        let data = {
            pageSize: -1,
            pageNum: 1,
            createUserId: user.shopCode,
            type: '挂车',
            vehicleSite: user.userType === '管理员' || user.userType === '超级管理员' ? user.createUser : '',
        }
        let { retData } = await trailerService.page(data)
        const { records } = retData
        setTrailerData(
            records?.map((item) => ({
                label: item.licensePlate,
                value: item.id,
            })),
        )
    }
    // 实时查询司机接口
    const fetchDriverList = async () => {
        let data = {
            pageSize: -1,
            pageNum: 1,
            createUserId: user.shopCode,
            type: '司机',
            fleet: user.userType === '管理员' || user.userType === '超级管理员' ? user.createUser : '',
        }
        let { retData } = await driverService.page(data)
        const { records } = retData
        setDriverData(
            records?.map((item) => ({
                label: item.driverName,
                value: item.id,
                md5: item.md5,
                photo: item.photo,
                type: '司机',
            })),
        )
    }
    // 实时查询押运员接口
    const fetchSupercargoList = async () => {
        let data = {
            pageSize: -1,
            pageNum: 1,
            createUserId: user.shopCode,
            type: '押运员',
            fleet: user.userType === '管理员' || user.userType === '超级管理员' ? user.createUser : '',
        }
        let { retData } = await supercargoService.page(data)
        const { records } = retData
        setSupercargoData(
            records?.map((item) => ({
                label: item.driverName,
                value: item.id,
                md5: item.md5,
                photo: item.photo,
                type: '押运员',
            })),
        )
    }
    // 实时查询维修技师接口
    const fetchMaintenanceTechnicianList = async () => {
        let data = {
            pageSize: -1,
            pageNum: 1,
            createUserId: user.shopCode,
            type: '维修技师',
        }
        let { retData } = await maintenanceTechnicianService.page(data)
        const { records } = retData
        setMaintenanceTechnicianData(
            records?.map((item) => ({
                label: item.driverName,
                value: item.id,
                md5: item.md5,
                photo: item.photo,
                company: item.company,
            })),
        )
    }
    // 实时查询路线接口
    const fetchRoutineList = async () => {
        let data = {
            pageSize: -1,
            pageNum: 1,
            createUserId: user.shopCode,
        }
        let { retData } = await routineService.page(data)
        const { records } = retData
        setRoutineData(
            records?.map((item) => ({
                label: item.lineName,
                value: item.lineName,
            })),
        )
    }
    // 实时查询公司接口
    const fetchCompanyList = async () => {
        let data = {
            type: 'company',
            createUserId: user.shopCode,
        }
        let { retData } = await fleetService.page(data)
        // const { records, ...pg } = retData
        setCompanyData(
            retData?.map((item: any) => ({
                label: item.institutionName,
                value: item.institutionName,
            })),
        )
    }
    // 实时查询现场接口
    const fetchFleetList = async () => {
        let data = {
            type: 'fleet',
            createUserId: user.shopCode,
        }
        let { retData } = await fleetService.page(data)
        setFleetData(
            retData?.map((item: any) => ({
                label: item.institutionName,
                value: item.institutionName,
            })),
        )
    }
    // 实时查询现场接口
    const fetchAuthList = async () => {
        let data = {
            pageSize: -1,
            pageNum: 1,
            createUserId: user.shopCode,
        }
        let { retData } = await authService.page(data)
        const { records } = retData
        setAuthData(
            records?.map((item) => ({
                label: item.name,
                value: item.name,
                type: item.type,
            })),
        )
    }
    // 实时头部字典接口
    const fetchDictList = async () => {
        let data = {
            pageSize: -1,
            pageNum: 1,
            createUserId: user.shopCode,
            itemCreateUser: user.createUser,
        }
        let { retData } = await threeTestItemService.page(data)
        const { records } = retData
        setDictHeaderData([
            {
                label: '出车前',
                value: records.find((item: any) => item.name === '出车前')?.code,
            },
            {
                label: '出车中',
                value: records.find((item: any) => item.name === '出车中')?.code,
            },
            {
                label: '收车后',
                value: records.find((item: any) => item.name === '收车后')?.code,
            },
        ])
    }
    //所有缓存加载
    const requestCacheAll = async () => {
        await fetchVehicleList()
        await fetchTrailerList()
        await fetchDriverList()
        await fetchSupercargoList()
        await fetchMaintenanceTechnicianList()
        await fetchRoutineList()
        await fetchCompanyList()
        await fetchFleetList()
        await fetchAuthList()
        await fetchDictList()
    }

    const [unreadNum] = useState<number>(0)

    return {
        user,
        setUser,
        resetUser,
        cm,
        toggleMenu,
        resetCm,
        loadingInfo,
        setLoadingInfo,
        whDs,
        requestCacheAll,
        supplierDs,
        // beDs,
        beDs,
        setBeDs,
        shopDs,
        setShopDs,
        resourceAuth,
        setResourceAuth,
        menuAuth,
        setMenuAuth,
        vehicleData,
        setVehicleData,
        trailerData,
        setTrailerData,
        driverData,
        setDriverData,
        supercargoData,
        setSupercargoData,
        maintenanceTechnicianData,
        setMaintenanceTechnicianData,
        routineData,
        setRoutineData,
        CustomerData,
        setCustomerData,
        clearCustomerData,
        ciDict,
        setCiDict,
        resetCiDict,
        ciGetTreeNodeValue,
        ciStaticResources,
        setCiStaticResources,
        resetCiStaticResources,
        getCiImgUrl,
        unreadNum,
        fetchVehicleList,
        fetchTrailerList,
        fetchDriverList,
        fetchSupercargoList,
        fetchMaintenanceTechnicianList,
        fetchRoutineList,
        fetchFleetList,
        fetchAuthList,
        setFleetData,
        fleetData,
        authData,
        setAuthData,
        fetchCompanyList,
        companyData,
        setCompanyData,
        dictHeaderData,
        setDictHeaderData,
        dealerNameData,
        setDealerNameData,
    }
}

export const useGlobalModel = createModel(useModel)
export default useGlobalModel
